import {ActionsColumn, Column, CRUD, CRUDActions, IdColumn, RowRenderer} from 'react-admin-base-bootstrap';
import {Breadcrumb} from 'react-admin-base-nazox';
import ShopEntity from "./ShopEntity";

export default function Shops() {
    return <Breadcrumb
        title="Shops"
        data={
            [
                {
                    href: '/shop',
                    name: 'Shops'
                }
            ]
        }
    >
        <CRUD url="/shop" Component={ShopEntity}>
            <thead>
                <tr>
                    <IdColumn/>
                    <Column sort="name">Name</Column>
                    <Column sort="company.name">Company</Column>
                    <ActionsColumn/>
                </tr>
            </thead>
            <RowRenderer
                render={row => <tr key={row.id}>
                    <td className="min text-center">{row.id}</td>
                    <td>{row.name}</td>
                    <td>{row.company.name}</td>
                    <CRUDActions
                        id={row.id}
                        edit
                        del={"/shop/" + row.id}
                    />
                </tr>}
            />
        </CRUD>
    </Breadcrumb>;
}
